import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import classes from "./FeedbackReview.module.css";
import util from "../../styles/utilities.module.css"; // Phase3: button utilities
import "../../style.css";
import "../../common/common_styles.css"
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCommentDots,
  faPaperPlane,
} from "@fortawesome/free-regular-svg-icons";
import ActionButton from "../UI/ActionButton/ActionButton";

import {
  selectAssignmentData,
  selectRubricData,
  selectStudentWorkData,
  selectAssignmentId,
  selectRubricId,
  selectGradingCalibrationId,
  selectSampleWorkId,
  selectStudentWorkId,
  selectGeneralFb,
  selectRubricCriteriaFb,
  selectCategoryFb,
  selectOverallFb,
  setGeneralFb,
  setRubricCriteriaFb,
  setCategoryFb,
  setOverallFb,
  setDefaultValues,
  editGeneralFb,
  editRubricCriteriaFb,
  editOverallFb,
  editCategoryFb,
  resetStudentWorkData,
  selectGradingCalibrationData,
  updateTeacherRubricGrade,
  updateTeacherRubricGradeData,
  selectTeacherRubricGrades,
  selectIssueCategories,
  selectSampleWorkData,
  selectSampleWorkInstructionsShown,
  selectOverviewShown,
} from "../../slices/gradingForm";

import CommentField from "../../common/Comment/CommentField";
import {
  useAppUsageLogger,
  useFeedbackMutation,
  useSaveExportGradingMutation,
  useGradeGeneralFeedbackMutation,
  useGradeCategoryFeedbackMutation,
  useGradeCalibratedRubricFeedbackMutation,
} from "../../slices/authApi";
import ModalWrapper from "../UI/modal_wrapper/modal_wrapper";
import ExportGradingModal from "../UI/export_grading_modal/export_grading_modal";
import InputModal from "../UI/input_modal/input_modal";
import DoneIcon from "@mui/icons-material/Done";
import Spinner, { InlineSpinner } from "../UI/spinner/spinner";
import SignInInfoModal from "../UI/signin_info_modal/signin_info_modal";
import openGoogleLogin from "../../common/openGoogleLogin";
import ErrorModal from "../UI/error_modal/error_modal";
import GradeAdjuster from "../UI/GradeAdjuster/GradeAdjuster";

const userFeedbackPlaceholder =
  "(Optional) Your feedback matters! Use this space to share your thoughts or suggestions, comment on something you really liked, let us know about an issue you ran into, tell us how you are using ClassGenius, or fill us in on a feature you would like to see added or changed.";
const afterSentUserFeedbackPlaceHolder =
  "You're awesome! We appreciate your feedback. Your thoughts and ideas help us make our product better for everyone.";

const GradeTextInput = React.memo(({ value, onChange, placeholder }) => {
    return (
        <input
            type="text"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
        />
    );
});

// Set default props
GradeTextInput.defaultProps = {
  value: "",
  onChange: () => {},
  placeholder: "",
};

function FeedbackReview({ step, previousStep }) {
  const location = useLocation();
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logAppUse = useAppUsageLogger();
  const [userFeedbackApi] = useFeedbackMutation();
  const [saveExportGrading, { isLoading: isSaveExportGradingLoading }] =
    useSaveExportGradingMutation();
  const rubricFeedbackReviewCompleteRef = useRef(false);
  const calibrationCompleteRef = useRef(false);
  const [categoryMinimumSpinnerTimePassed, setCategoryMinimumSpinnerTimePassed] = useState(false);
  const [gradeGeneralFeedback, { isLoading: isGradeGeneralFeedbackLoading }] =
    useGradeGeneralFeedbackMutation();
  const [gradeCategoryFeedback, { isLoading: isGradeCategoryFeedbackLoading }] =
    useGradeCategoryFeedbackMutation();
  const [gradeCalibratedRubricFeedback, { isLoading: isGradeCalibratedRubricFeedbackLoading }] =
    useGradeCalibratedRubricFeedbackMutation();

  const assignmentData = useSelector(selectAssignmentData);
  const rubricData = useSelector(selectRubricData);
  const studentWorkData = useSelector(selectStudentWorkData);
  const sampleWorkData = useSelector(selectSampleWorkData);
  const gradingCalibrationData = useSelector(selectGradingCalibrationData);
  const issue_categories = useSelector(selectIssueCategories);

  const selectedCategoryCount =rubricData.issue_categories.filter((cat)=>cat.selected===true).length;

  const assignmentId = useSelector(selectAssignmentId);
  const rubricId = useSelector(selectRubricId);
  const sampleWorkId = useSelector(selectSampleWorkId);
  const gradingCalibrationId = useSelector(selectGradingCalibrationId);
  const studentWorkId = useSelector(selectStudentWorkId);

  const generalFb = useSelector(selectGeneralFb);
  const rubricCriteriaFb = useSelector(selectRubricCriteriaFb);
  const categoryFb = useSelector(selectCategoryFb);
  const overallFb = useSelector(selectOverallFb);

  const teacherRubricGrades = useSelector(selectTeacherRubricGrades);
    
  const [userFeedback, setUserFeedback] = useState("");

  const [updatedFbText, setUpdatedFbText] = useState("");
  const fileMetadata = useMemo(
    () => location.state?.fileMetadata || [],
    [location.state?.fileMetadata]
  );
  
  const [errMsg, setErrMsg] = useState("");

  const [comment, setComment] = useState("");

  const [commentFeedback, setCommentFeedback] = useState("");
  const [editFeedback, setEditFeedback] = useState("");
  const [currentFeedbackGroup, setCurrentFeedbackGroup] = useState("");

  const [adjustingRubricGrades, setAdjustingRubricGrades] = useState(false);

  const [backToHomeModal, setBackToHomeModal] = useState(false);
  const [assignGradeModal, setAssignGradeModal] = useState(false);
  const [exportModal, setExportModal] = useState(false);
  const [exportedUrl, setExportedUrl] = useState("");
  
  const [isUserFeedbackSent, setIsUserFeedbackSent] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [exportError, setExportError] = useState(false);

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [fileUploadMessage, setFileUploadMessage] = useState("");

  const [teacherGrade, setTeacherGrade] = useState("");
  const [postGradeCheckHandler, setPostGradeCheckHandler] = useState(() => () => {});

  const [saveExportSpinnerMsg, setSaveExportSpinnerMsg] = useState("");

  const [calibratedRubricFeedbackPreLoad, setCalibratedRubricFeedbackPreLoad] = useState(true);

  const [gradingInputs, setGradingInputs] = useState({});
  const overviewShown = useSelector(selectOverviewShown);
  const sampleWorkInstructionsShown = useSelector(selectSampleWorkInstructionsShown);


    // save & export endpoint - pass a boolean indicating whether to do the export or just save
  const saveAndExportEndpoint = async (data) => {
    const { doExport } = data || {};
    setSaveExportSpinnerMsg(doExport ? "We are creating your exported file." : "");

    try {
        const saveExportResponse = await saveExportGrading({ 
        doExport,
        generalFb,
        rubricCriteriaFb,
        categoryFb,
        overallFb,
        teacherGrade
    });
      return saveExportResponse;
    } catch (err) {
      console.log({ err });
    }
  };

  // CG user feedback endpoint
  const userFeedbackEndpointHandler = async () => {
    if (userFeedback) {
      try {
        // feedback payload
        const payload = {
          feedback: [
            {
              assignmentId: [assignmentId],
              rubricId: {rubricId},
              sampleWorkId: {sampleWorkId},
              studentWorkId: {studentWorkId},
              category: "grading",
              comments: userFeedback,
            },
          ],
        };
        await userFeedbackApi(payload);
        setUserFeedback("");
        !isUserFeedbackSent && setIsUserFeedbackSent(true);
      } catch (err) {
        console.log({ err });
      }
    }
  };

  const fbGroupActionDispatchers = {
    general: setGeneralFb,
    rubric: setRubricCriteriaFb,
    category: setCategoryFb,
    overall: setOverallFb,
  };


  const feedbackCommentHandler = () => {
    const updatedFeedback = {
      ...commentFeedback,
      comments: comment,
    };

    // Overall group is just a single feedback, vs needing to replace in the array for other groups
    const updatedFbGroupWithComment = 
    (currentFeedbackGroup.type === "overall") ? updatedFeedback :
      {
        ...currentFeedbackGroup,
        feedbacks: currentFeedbackGroup.feedbacks.map((fb) =>
          fb.id === updatedFeedback?.id
            ? updatedFeedback
            : fb
          )
      };

    dispatch(
      fbGroupActionDispatchers[currentFeedbackGroup.type](updatedFbGroupWithComment)
    );
    setComment("");
    setCommentFeedback("");
    setCurrentFeedbackGroup(null);
  };

  const checkIfWorkGraded = async (postCheckHandler) => {
    // If the user has not assigned a grade, show the assign grade modal
    if (!teacherGrade) {
      setPostGradeCheckHandler(() => postCheckHandler);
      setAssignGradeModal(true);
    } else {
      saveAndExportEndpoint({ doExport: false});
      postCheckHandler();
    }
  }
    
  const gradeAnotherHandler = async () => {
    await logAppUse("feedbackReview", "studentWork");
    // Going to grade another student, ask for grade if not entered
    checkIfWorkGraded( () => {
      dispatch(resetStudentWorkData());
      navigate("/grading/studentWork");
    });
  };

  const backToHomeHandler = async () => {
    await logAppUse("feedbackReview", "back_to_home_pop_up");
    await userFeedbackEndpointHandler();
    setBackToHomeModal(true);
  };

  const backToHomeCancelBtnHandler = async () => {
    await saveAndExportEndpoint({ doExport: false });
    await logAppUse("back_to_home_pop_up", "feedbackReview");
    setBackToHomeModal(false);
  };

  const backToHomeConfirmBtnHandler = async () => {
    localStorage.removeItem("from");

    await saveAndExportEndpoint({ doExport: false });
    await logAppUse("back_to_home_pop_up", "tool_selection");
    setBackToHomeModal(false);
    // Going back home, ask for grade if not entered
    checkIfWorkGraded(() => {
      dispatch(setDefaultValues());
      navigate("/toolSelection");
    });
  };

  const exportHandler = async () => {
    // Don't allow export until feedback is done loading from backend
    if (isGradeCategoryFeedbackLoading || isGradeGeneralFeedbackLoading)
      return;
    await logAppUse("feedbackReview", "grading_export_pop_up");
    await userFeedbackEndpointHandler();
    setExportModal(true);
  };

  const backBtnExportModalHandler = async () => {
    await saveAndExportEndpoint({ doExport: false });
    setExportModal(false);
    await logAppUse("grading_export_pop_up", "feedbackReview");
  };

  const continueBtnExportModalHandler = async () => {
    setExportModal(false);
    await finalStepInExportHandler();
  };

  const finalStepInExportHandler = async () => {
    const exportResponse = await saveAndExportEndpoint({
      doExport: true,
    });
    await logAppUse("grading_export_pop_up", "grading_export_url");
    if (exportResponse?.data?.status === 200) {
      localStorage.setItem("preserveData", null);
      setExportedUrl(exportResponse?.data?.url);
      // Successful export, ask for grade if not entered
      checkIfWorkGraded(() => {});
    } else {
      setExportError(exportResponse?.data?.status === 500);
      setInfoModal(true);
    }
  };

  const getCommentFieldModal = (fbGroup, feedbackId) => {
    return commentFeedback?.id === feedbackId &&
      fbGroup.type === currentFeedbackGroup?.type ? (
      <CommentField
        valueHandler={(comment) => setComment(comment)}
        cancelHandler={() => setCommentFeedback("")}
        saveHandler={feedbackCommentHandler}
        comment={comment}
        placeholder={"share your comments with ClassGenius about this"}
      />
    ) : null;
  };

  const getSelectBox = (isSelected, clickHandler) => {
    return (
      <div
        onClick={clickHandler}
        className={classes.selectBox}
        style={{
          borderColor: isSelected ? "#0097F0" : "#bbbbbb",
          marginBottom: "20px",
        }}
      >
        {isSelected ? (
          <DoneIcon sx={{ color: "#0097F0", fontSize: "24px" }} />
        ) : null}
      </div>
    );
  };

  const feedbackSelectedHandler = (feedbackGroup, feedbackId) => {
    const updatedFeedbacks = feedbackGroup.feedbacks.map((feedback) =>
      feedback.id === feedbackId
        ? { ...feedback, selected: !feedback.selected }
        : feedback
    );

    const updatedFeedbackGroup = {
      ...feedbackGroup,
      feedbacks: updatedFeedbacks,
    };

    dispatch(
      fbGroupActionDispatchers[feedbackGroup.type](updatedFeedbackGroup)
    );
  };

  const overallFbSelectedHandler = () => {
    dispatch(
      setOverallFb({
        ...overallFb,
        selected: !overallFb.selected,
      })
    );
  };

  const rubricCriteriaFbUpdateHandler = (fb) => {
    dispatch(
      editRubricCriteriaFb({
        fb_id: fb.id,
        fbText: updatedFbText,
      })
    );
    setEditFeedback(null);
  };

  const categoryFbUpdateHandler = (fb) => {
    dispatch(
      editCategoryFb({
        fb_id: fb.id,
        fbText: updatedFbText,
      })
    );
    setEditFeedback(null);
  };

  const generalFbUpdateHandler = (fb) => {
    dispatch(
      editGeneralFb({
        fb_id: fb.id,
        fbText: updatedFbText,
      })
    );
    setEditFeedback(null);
  };

  const userFeedbackSendHandler = async () => {
    await userFeedbackEndpointHandler();
  };

  const overallFbUpdateHandler = (fb) => {
    dispatch(
      editOverallFb({
        ...fb,
        fbText: updatedFbText,
      })
    );
    setEditFeedback(null);
  };

  const signInInfoContinueHandler = () => {
    localStorage.setItem(
      "preserveData",
      JSON.stringify({
        sourcePage: "feedbackReview",
        generalFb,
        rubricCriteriaFb,
        categoryFb,
        overallFb,
        assignmentId,
        rubricId,
        sampleWorkId,
        studentWorkId,
        assignmentData,
        sampleWorkData,
        rubricData,
        studentWorkData,
        userFeedback,
        teacherGrade,
        gradingCalibrationData,
        gradingCalibrationId,
        teacherRubricGrades,
        issue_categories,
        overviewShown,
        sampleWorkInstructionsShown
      })
    );
    openGoogleLogin();
  };

  const getIconStyle = (isTrue) => {
    return `${classes.icon} ${isTrue ? classes["icon-color"] : ""}`;
  };

  useEffect(() => {
    if (exportedUrl) {
      window.open(exportedUrl, "_blank", "noreferrer");
      setExportedUrl("");
    }
  }, [exportedUrl]);

  const checkFileUploadMessage = (metadata) => {
    let message = "";
    metadata.forEach((file) => {
      // Check if OCR confidence is below a threshold (e.g., 80)
      if (file.ocr_confidence < 80) {
        message += `${file.name} - difficult to read and may need to be rescanned.\n\n`;
      }
    });
    setFileUploadMessage(message);
  };

  // Use effect to check and set the message when metadata changes
  useEffect(() => {
    if (fileMetadata && fileMetadata.length > 0) {
      checkFileUploadMessage(fileMetadata);
    }
  }, [fileMetadata]);

  const getGeneralFeedback = React.useCallback(async () => {
    try {
      const generalFeedbackData = await gradeGeneralFeedback({
        assignment_id: assignmentId,
        rubric_id: rubricId,
        sample_work_id: sampleWorkId,
        student_work_id: studentWorkId,
      });
   
      const updatedStrengthsText = generalFeedbackData?.data?.strengths;
      const updatedGrowthAreasText = generalFeedbackData?.data?.growth_areas;

      dispatch(
        setGeneralFb({
          ...generalFb,
          grading_id: generalFeedbackData?.data?.grading_id,
          feedbacks: generalFb.feedbacks.map((fb) => {
            if (fb.generalCategory === "Strengths") {
              return {
                ...fb,
                fbText: updatedStrengthsText,
              };
            } else if (fb.generalCategory === "Areas for growth") {
              return {
                ...fb,
                fbText: updatedGrowthAreasText,
              };
            }
            return fb;
          }),
        })
      );

    } catch (err) {
      if (!err?.status) {
        setErrMsg("No Server Response");
      } else if (err.status === 401) {
        setErrMsg("Unauthorized");
      } else {
        let err_message = "";
        if (err.data.message) {
          err_message = err.data.message;
        } else {
          err_message = err.status + " Server Error ";
        }
        setErrMsg(err_message);
      }
    }
 
  }, [assignmentId, rubricId, sampleWorkId, studentWorkId, gradeGeneralFeedback, dispatch, generalFb]);

  const getCalibratedRubricFeedback = useCallback(async (regradeCount) => {
    try {
      // Add regrade_count to teacherRubricGrades if regradeCount > 0
      const updatedTeacherRubricGrades = regradeCount > 0 
        ? { ...teacherRubricGrades, regrade_count: regradeCount } 
        : null;
      const rubricCriteriaFeedbackData = await gradeCalibratedRubricFeedback({
        assignment_id: assignmentId,
        rubric_id: rubricId,
        sample_work_id: sampleWorkId,
        student_work_id: studentWorkId,
        grading_calibration_id: gradingCalibrationId,
        teacher_rubric_grades: updatedTeacherRubricGrades
      });

      const grading_id = rubricCriteriaFeedbackData?.data?.grading_id;
      const updatedOverallFeedback = rubricCriteriaFeedbackData?.data?.overall_feedback;
      dispatch(setOverallFb({
        ...overallFb,
        grading_id: grading_id,
        fbText: updatedOverallFeedback
      }));

      const updatedRubricCriteriaFeedbacks = rubricCriteriaFeedbackData?.data?.rubric_feedback.map((feedback) => ({
       ...feedback,
       selected: true
       }));
      dispatch(setRubricCriteriaFb({
        ...rubricCriteriaFb,
        grading_id: grading_id,
        feedbacks: updatedRubricCriteriaFeedbacks
      }));
      // Update grades that will be sent as teacher rubric grades on a regrade - don't want
      // the non-changed grades to change on a regrade, so save them in the data that will be sent
      updatedRubricCriteriaFeedbacks.forEach((fb, index) => {
        dispatch(updateTeacherRubricGrade({criterion: fb.criterion, grade: fb.numeric_grade}));
      });
      // Retrieve all grading inputs as object for testing purposes
      setGradingInputs(rubricCriteriaFeedbackData?.data?.grading_inputs);

    } catch (err) {
      if (!err?.status) {
        setErrMsg("No Server Response");
      } else if (err.status === 401) {
        setErrMsg("Unauthorized");
      } else {
        let err_message = "";
        if (err.data.message) {
          err_message = err.data.message;
        } else {
          err_message = err.status + " Server Error ";
        }
        setErrMsg(err_message);
      }
    }
  }, [assignmentId, rubricId, sampleWorkId, studentWorkId, gradingCalibrationId, teacherRubricGrades, 
      overallFb, rubricCriteriaFb, dispatch, gradeCalibratedRubricFeedback, setErrMsg]);

  const getCategoryFeedback = useCallback(async () => {
    try {
      const categoryFeedbackData = await gradeCategoryFeedback({
        assignment_id: assignmentId,
        rubric_id: rubricId,
        sample_work_id: sampleWorkId,
        student_work_id: studentWorkId,
      });

      const updatedCategoryFeedbacks = categoryFeedbackData?.data?.category_feedback?.map((feedback) => ({
       ...feedback,
       selected: true
       }));
      dispatch(setCategoryFb({
        ...categoryFb,
        grading_id: categoryFeedbackData?.data?.grading_id,
        feedbacks: updatedCategoryFeedbacks
      }));

    } catch (err) {
      if (!err?.status) {
        setErrMsg("No Server Response");
      } else if (err.status === 401) {
        setErrMsg("Unauthorized");
      } else {
        let err_message = "";
        if (err.data.message) {
          err_message = err.data.message;
        } else {
          err_message = err.status + " Server Error ";
        }
        setErrMsg(err_message);
      }
    }
  }, [assignmentId, rubricId, sampleWorkId, studentWorkId, categoryFb, dispatch, gradeCategoryFeedback, setErrMsg]);


  const getGeneralFeedbackDisplay = () => {
    if (step !== "feedbackReview") {
      return null;
    }
    return (
      <div>
        {generalFb.generalCategories?.map((genCategory, catIndex) => {
            
            return (
              <div key={catIndex}>
                <h2 className={`${classes.title} ${classes.multipleSpacer}`}>
                  
                  {genCategory}
                </h2>
                {generalFb.feedbacks?.filter(fb => fb.generalCategory === genCategory).map((fb, index) => {
                  const isEditing = (editFeedback?.generalCategory === fb.generalCategory) && 
                                    (currentFeedbackGroup.type === generalFb.type);
                  return (
                    <div key={index} className={classes.question}>
                      {getSelectBox(fb.selected, () =>
                        feedbackSelectedHandler(generalFb, fb.id)
                      )}
                      <div className={classes.fullWidth}>
                        <div className={classes["content-wrapper"]}>
                          <div
                            className={`${
                              fb.selected
                                ? classes["paragraph-box"]
                                : classes["paragraph-box-unselect"]
                            } ${isEditing ? classes["editing"] : ""}`}
                          >
                            {isEditing ? (
                              // Editing general feedback
                              <div>
                                <textarea
                                  className={classes["editable-text"]}
                                  value={`${updatedFbText}`}
                                  onChange={(e) => 
                                    setUpdatedFbText(e.target.value)
                                  }
                                  rows={Math.max(3, Math.ceil(updatedFbText.length / 40))}
                                />
                                <div className={classes["icon-container"]}>
                                  <button
                                    type="button"
                                    className={`${util.btn} ${util['btn--ghost']} ${util['btn-sm']}`}
                                    onClick={() => {
                                      setEditFeedback(null);
                                      setErrMsg("");
                                    }}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    className={`${util.btn} ${util['btn-sm']}`}
                                    onClick={() => generalFbUpdateHandler(fb)}
                                  >
                                    Update
                                  </button>
                                </div>
                              </div>
                            ) : fb.selected ? (
                              // Selected, not editing general feedback
                                <div className={classes.feedbackContainer}>
                                  <div className={classes.alignItem}>
                                    <p>
                                      {fb.fbText}
                                    </p>
                                    <div className={classes.verticalContainer}>
                                      <button
                                        className={`${util.btn} ${util['btn--ghost']} ${util['btn-sm']}`}
                                        onClick={() => {
                                          setEditFeedback(fb);
                                          setUpdatedFbText(fb.fbText);
                                          setCurrentFeedbackGroup(generalFb);
                                        }}
                                        >
                                        Edit feedback
                                      </button>
                                      <div style={{display: "flex", flexGrow: 1}}> &nbsp;{/* spacer */} </div>
                                      <div className={classes["icon-container-bottom"]}>
                                          <FontAwesomeIcon
                                            className={getIconStyle(fb?.comments)}
                                            icon={faCommentDots}
                                            onClick={() => {
                                              setCommentFeedback(fb);
                                              setCurrentFeedbackGroup(generalFb);                                              
                                              setComment(fb?.comments || "");
                                            }}
                                          />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            ) : (
                              // Unselected general feedback
                              <div>
                                <div className={classes.alignItem}>
                                  <p style={{ width: "80%", color: "#777" }}>
                                    {fb.fbText}
                                  </p>
                                </div>
                              </div>
                            )}
                            {getCommentFieldModal(generalFb, fb.id)}
                          </div>
                        </div>
                        <div style={{ paddingTop: "20px" }} />
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
      </div>
    );
  };

  function getGradeLabelsForCriterion(criterion) {
    const criteria = gradingCalibrationData.criteria;
    const matchingCriterion = criteria.find(item => item.criterion === criterion);
  
    if (matchingCriterion) {
      return matchingCriterion.gradation_levels;
    } else {
      return [];
    }
  }

  const getRubricCriteriaFeedbackDisplay = () => {
    return (
      <div>
        <h2 className={`${classes.title} ${step === "feedbackReview" ? (classes.multipleSpacer) : (classes.topSpacer) }`}>
          {rubricCriteriaFb.header}
        </h2>
          {rubricCriteriaFb.feedbacks?.map((fb, index) => {
            const isEditing = (editFeedback?.id === fb.id) && 
                              (currentFeedbackGroup.type === rubricCriteriaFb.type);
            const finalReview = step === "feedbackReview";

            return (
              <div key={index} className={classes.question}>
                {finalReview ? 
                  getSelectBox(fb.selected, () =>
                    feedbackSelectedHandler(rubricCriteriaFb, fb.id)
                  ) : null
                }
                <div className={classes.fullWidth}>
                  <div className={classes["content-wrapper"]}>
                    <div
                      className={`${
                        fb.selected
                          ? classes["paragraph-box"]
                          : classes["paragraph-box-unselect"]
                      } ${isEditing ? classes["editing"] : ""}`}
                    >
                      {isEditing ? (
                        // Editing rubric criteria feedback
                        <div>
                          Criterion: {fb.criterion}
                          <br/><br/>
                          Grade: {fb.rubric_grade}
                          <br/><br/>
                            <textarea
                              className={`${classes["editable-text"]} 
                                          ${classes["light-border"]}`}
                              value={`${updatedFbText}`}
                              onChange={(e) =>
                                setUpdatedFbText(e.target.value)                              
                              }
                              rows={Math.max(3, Math.ceil(updatedFbText.length / 40))}
                            />
                          <div className={classes["icon-container"]}>
                            <button
                              type="button"
                              className={`${util.btn} ${util['btn--ghost']} ${util['btn-sm']}`}
                              onClick={() => {
                                setEditFeedback(null);
                                setErrMsg("");
                              }}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className={`${util.btn} ${util['btn-sm']}`}
                              onClick={() => rubricCriteriaFbUpdateHandler(fb)}
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      ) : fb.selected ? (
                        // Selected, not editing rubric criteria feedback
                            <div className={classes.feedbackContainer}>
                            <div className={classes.alignItem}>
                              <p>
                              Criterion: {fb.criterion}
                              </p>
                              {adjustingRubricGrades ? (
                              <div style={{ width: '24px' }}></div>
                              ) : (
                              <>
                              {finalReview ? (
                                <button
                                className={`${util.btn} ${util['btn--ghost']} ${util['btn-sm']}`}
                                onClick={() => {
                                  setEditFeedback(fb);
                                  setUpdatedFbText(fb.fbText);
                                  setCurrentFeedbackGroup(rubricCriteriaFb);
                                }}
                                >
                                Edit feedback
                                </button>
                              ) : (null)
                              }
                              </>
                              )}
                            </div>
                            <br/>
                            <div className={classes.alignItem}>
                              <div className="full-width">
                              {adjustingRubricGrades ? (
                              <div>
                                <div style={{ display: 'flex', alignItems: 'center', margin: '0 0 10px 0' }}>
                                <div style={{ alignSelf: 'flex-start'}}>
                                  Grade: 
                                </div>                                  
                                <GradeAdjuster 
                                  initialGrade={fb.numeric_grade} 
                                  gradeLabels={getGradeLabelsForCriterion(fb.criterion)}
                                  onChange={(value) => {
                                        dispatch(updateTeacherRubricGrade({criterion: fb.criterion, grade: value}));
                                      }}
                                  addSliderMargin={gradingCalibrationData.is_letter_grade_scale}
                                    />
                                  </div>
                                  <i>Originally: {fb.rubric_grade}
                                  <br/><br/>
                                  {fb.fbText}</i>
                                </div>
                                ) : (
                                  <>
                                    Grade: {fb.rubric_grade}
                                    <br/>
                                    <br/>
                                    {fb.fbText}
                                  </>
                                )}
                                
                                
                              </div>
                              {finalReview ? (
                                <div className={classes.verticalContainer}>
                                    <div style={{display: "flex", flexGrow: 1}}> &nbsp;{/* spacer */} </div>
                                    <div className={classes["icon-container-bottom"]}>
                                      {adjustingRubricGrades ? (
                                        <div style={{ width: '24px' }}></div>
                                      ) : (
                                        <>
                                          <FontAwesomeIcon
                                            className={getIconStyle(fb?.comments)}
                                            icon={faCommentDots}
                                            onClick={() => {
                                              setCommentFeedback(fb);
                                              setCurrentFeedbackGroup(rubricCriteriaFb);                                        
                                              setComment(fb?.comments || "");
                                            }}
                                          />
                                        </>
                                      )}
                                    </div>
                                </div>
                              ) : (null)}
                            </div>
                          </div>
                      ) : (
                        // Unselected rubric criteria feedback
                        <div>
                          <div className={classes.alignItem}>
                            <p style={{ width: "80%", color: "#777" }}>
                              Criterion: {fb.criterion}
                            </p>
                          </div>
                        </div>
                      )}
                      {getCommentFieldModal(rubricCriteriaFb, fb.id)}
                    </div>
                  </div>
                  <div style={{ paddingTop: "20px" }} />
                </div>
              </div>
            );
          })}
        </div>
    );
  };

  const getCategoryFeedbackDisplay = () => {
    if (selectedCategoryCount === 0 || step !== "feedbackReview") {
      return null;
    }
    return (
      <div>
        <h2 className={`${classes.title} ${classes.multipleSpacer}`}>
            {categoryFb.header}
          </h2>
          {categoryFb.feedbacks?.map((fb, index) => {
            const isEditing = (editFeedback?.id === fb.id) && 
                              (currentFeedbackGroup.type === categoryFb.type);
            return (
              <div key={index} className={classes.question}>
                {getSelectBox(fb.selected, () =>
                  feedbackSelectedHandler(categoryFb, fb.id)
                )}
                <div className={classes.fullWidth}>
                  <div className={classes["content-wrapper"]}>
                    <div
                      className={`${
                        fb.selected
                          ? classes["paragraph-box"]
                          : classes["paragraph-box-unselect"]
                      } ${isEditing ? classes["editing"] : ""}`}
                    >
                      {isEditing ? (
                        // Editing category specific feedback
                        <div>
                          Category: {fb.category}
                          <br/>
                          <br/>
                          <textarea
                            className={`${classes["editable-text"]} 
                                        ${classes["light-border"]}`}
                            value={`${updatedFbText}`}
                            onChange={(e) =>
                              setUpdatedFbText(e.target.value)                              
                            }
                            rows={Math.min(8, Math.max(3, Math.ceil(updatedFbText.length / 40), (updatedFbText.match(/\n/g) || []).length + 1))}
                          />
                          <div className={classes["icon-container"]}>
                            <button
                              type="button"
                              className={`${util.btn} ${util['btn--ghost']} ${util['btn-sm']}`}
                              onClick={() => {
                                setEditFeedback(null);
                                setErrMsg("");
                              }}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className={`${util.btn} ${util['btn-sm']}`}
                              onClick={() => categoryFbUpdateHandler(fb)}
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      ) : fb.selected ? (
                        // Selected, not editing category specific feedback
                        <div className={classes.feedbackContainer}>
                        <div className={classes.alignItem}>
                          <p>
                            Category: {fb.category}
                          </p>
                          <div>
                            <button
                              className={`${util.btn} ${util['btn--ghost']} ${util['btn-sm']}`}
                              onClick={() => {
                                setEditFeedback(fb);
                                setUpdatedFbText(fb.fbText);
                                setCurrentFeedbackGroup(categoryFb);
                              }}
                            >
                              Edit feedback
                            </button>
                          </div>
                        </div>
                        <br/>
                        <div className={classes.alignItem}>
                          <p>
                            {fb.fbText}
                          </p>
                          <div className={classes["icon-container-bottom"]}>
                            <FontAwesomeIcon
                              className={getIconStyle(fb?.comments)}
                              icon={faCommentDots}
                              onClick={() => {
                                setCommentFeedback(fb);
                                setCurrentFeedbackGroup(categoryFb);                                
                                setComment(fb?.comments || "");
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      ) : (
                        // Unselected category feedback
                        <div>
                          <div className={classes.alignItem}>
                            <p style={{ width: "80%", color: "#777" }}>
                              Category: {fb.category}
                            </p>
                          </div>
                        </div>
                      )}
                      {getCommentFieldModal(categoryFb, fb.id)}
                    </div>
                  </div>
                  <div style={{ paddingTop: "20px" }} />
                </div>
              </div>
            );
            })}
      </div>
    );
  };

  const regenerateFeedbackAfterRegrade = async () => {
    const updatedRegradeCount = teacherRubricGrades.regrade_count + 1;
    dispatch(updateTeacherRubricGradeData({regrade_count: updatedRegradeCount}));
    getCalibratedRubricFeedback(updatedRegradeCount);
    setAdjustingRubricGrades(false);
    rubricFeedbackReviewCompleteRef.current = false;
  };

  const getGradeAdjustmentButtons = () => {
    if (isGradeCalibratedRubricFeedbackLoading || calibratedRubricFeedbackPreLoad) {
      return null;
    }

    if ((step === "rubricGradesReview") && !(adjustingRubricGrades)) {
      return (
          <div className={classes["question"]}>
          <button
            type="button"
            className={`${util.btn}`}
            style={{ width: "330px" }}
            onClick={() => {
              setAdjustingRubricGrades(true);
              }}
            >
              Manually adjust the grades above and regenerate feedback
            </button>
        </div>
      )
    } else if (adjustingRubricGrades) {
      return (
        <div className={classes["question"]}>
           <div className={classes["icon-container"]}>
                    <button
                      type="button"
                      className={`${util.btn} ${util['btn--ghost']}`}
                      style={{ width: "330px" }}
                      onClick={() => {
                        setAdjustingRubricGrades(false);
                      }}
                    >
                      Cancel changes
                    </button>
            <button
            type="button"
            className={`${util.btn}`}
            style={{ width: "330px" }}
            onClick={regenerateFeedbackAfterRegrade}
            >
              Save, regenerate feedback
            </button>
          </div>
        </div>
      );
    }
  };

  const getOverallFeedbackDisplay = () => {
    if (adjustingRubricGrades) {
      return null;
    }

    return (
      <div className={classes.question}>
              {step === "feedbackReview" ?
                getSelectBox(overallFb.selected, () =>
                  overallFbSelectedHandler()
                )
                : null
              }
              <div className={classes.fullWidth}>
                <div className={classes["content-wrapper"]}>
                <div
                  className={`${
                  overallFb.selected
                    ? classes["paragraph-box"]
                    : classes["paragraph-box-unselect"]
                  } ${(editFeedback?.id === overallFb.id) ? classes["editing"] : ""}`}
                >
                  {(editFeedback?.id === overallFb.id) ? (
                  // Editing overall feedback
                  <div>
                    <textarea
                    className={classes["editable-text"]}
                    value={`${updatedFbText}`}
                    onChange={(e) => setUpdatedFbText(e.target.value)}
                    rows={Math.max(3, Math.ceil(updatedFbText.length / 40))}
                    />
                    <div className={classes["icon-container"]}>
                    <button
                      type="button"
                      className={`${util.btn} ${util['btn--ghost']} ${util['btn-sm']}`}
                      onClick={() => {
                      setEditFeedback(null);
                      setErrMsg("");
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className={`${util.btn} ${util['btn-sm']}`}
                      onClick={() => overallFbUpdateHandler()}
                    >
                      Update
                    </button>
                    </div>
                  </div>
                  ) : overallFb.selected ? (
                  // Selected, not editing overall feedback
                  <div className={classes.feedbackContainer}>
                    <div className={classes.alignItem}>
                    <p style={{ display: 'flex', alignItems: 'center'}}>
                      <b>{overallFb.fbText}</b>
                    </p>
                    {step === "feedbackReview" ? 
                      (
                        <div className={classes.verticalContainer}>
                          <button
                          className={`${util.btn} ${util['btn--ghost']} ${util['btn-sm']}`}
                            onClick={() => {
                              setEditFeedback(overallFb);
                              setUpdatedFbText(overallFb.fbText);
                              setCurrentFeedbackGroup(overallFb);
                            }}
                          >
                            Edit feedback
                          </button>
                          <div style={{ display: "flex", flexGrow: 1 }}>
                            &nbsp;{/* spacer */}
                          </div>
                          <div className={classes["icon-container-bottom"]}>
                          <FontAwesomeIcon
                            className={getIconStyle(overallFb?.comments)}
                            icon={faCommentDots}
                            onClick={() => {
                            setCommentFeedback(overallFb);
                            setCurrentFeedbackGroup(overallFb);                        
                            setComment(overallFb?.comments || "");
                            }}
                          />
                          </div>
                        </div>
                      ) : null
                    }
                    </div>
                  </div>
                  ) : (
                  // Unselected general feedback
                  <div>
                    <div className={classes.alignItem}>
                    <p style={{ width: "80%", color: "#777" }}>
                      {overallFb.fbText}
                    </p>
                    </div>
                  </div>
                  )}
                  {getCommentFieldModal(overallFb, overallFb.id)}
                </div>
                </div>
                <div style={{ paddingTop: "20px" }} />
              </div>
            </div>
    );
  };


  const generateDownloadLink = (gradingInputs) => {
    // Convert the object to a JSON string
    const jsonString = JSON.stringify(gradingInputs, null, 2);

    // Create a Blob from the JSON string
    const blob = new Blob([jsonString], { type: 'application/json' });

    // Create a URL for the Blob
    const url = window.URL.createObjectURL(blob);

    return url;
  };

  useEffect(() => {
    // Check if we're returning from Google auth by looking for the preserved data flag
    const preserveData = localStorage.getItem('preserveData');
    const isReturningFromAuth = preserveData && JSON.parse(preserveData) && 
                               JSON.parse(preserveData).sourcePage === "feedbackReview";
  
    // Get rubric and category feedback once, when gradingCalibrationId is available
    if (!calibrationCompleteRef.current && gradingCalibrationId) {
      if (!isReturningFromAuth) {
        // Only fetch rubric feedback if we aren't returning from export authentication
        getCalibratedRubricFeedback();
        if (selectedCategoryCount > 0) {
          // Only fetch category feedback if there were any selected categories
          getCategoryFeedback();
        }
      }
      setCalibratedRubricFeedbackPreLoad(false);

      calibrationCompleteRef.current = true;
    }
    // Set local teacher grade variable for storing to backend if already set on previous page
    setTeacherGrade(studentWorkData?.preliminaryGrade);

  }, [gradingCalibrationId, getCalibratedRubricFeedback, studentWorkData.preliminaryGrade, 
      selectedCategoryCount, getCategoryFeedback]);

  useEffect(() => {
    /// Check if we're returning from Google auth by looking for the preserved data flag
    const preserveData = localStorage.getItem('preserveData');
    const isReturningFromAuth = preserveData && JSON.parse(preserveData) && 
                               JSON.parse(preserveData).sourcePage === "feedbackReview";

    // Get general feedback once, when step is feedbackReview (may use updated rubric grades, though don't currently)
    if (!rubricFeedbackReviewCompleteRef.current && step === "feedbackReview") {
      if (!isReturningFromAuth) {
        // Only fetch general feedback if we aren't returning from export authentication
        getGeneralFeedback();
      }
      // Kick off a timer to show a spinner for a brief period for category feedback, even if it is ready at feedbackReview time
      setTimeout(() => {
        setCategoryMinimumSpinnerTimePassed(true);
      }, 2000);
      rubricFeedbackReviewCompleteRef.current = true;
    }
  }, [step, getGeneralFeedback]);

  return (
    <>
      {isSaveExportGradingLoading ? (
        <Spinner
          message={saveExportSpinnerMsg}
        />
      ) : null}
      <div className={classes["container"]}>
        <br />
        {(isGradeCalibratedRubricFeedbackLoading || calibratedRubricFeedbackPreLoad) ? (
          null
        ) : (
          <>
            {getOverallFeedbackDisplay()}
          </>
        )}
        <br />
        {(isGradeCalibratedRubricFeedbackLoading || calibratedRubricFeedbackPreLoad) ? (
          <InlineSpinner
            message={"Working on rubric feedback."}
          />
        ) : getRubricCriteriaFeedbackDisplay()}        
        {(isGradeGeneralFeedbackLoading || !rubricFeedbackReviewCompleteRef.current) 
          && step === "feedbackReview" ? (
          <InlineSpinner
            message={"Working on strengths and areas for growth."}
          />
        ) : getGeneralFeedbackDisplay()}
                {(isGradeCategoryFeedbackLoading || !rubricFeedbackReviewCompleteRef.current || !categoryMinimumSpinnerTimePassed) && 
         selectedCategoryCount > 0 && step === "feedbackReview" ? (
          <InlineSpinner
            message={"Working on category feedback."}
          />
        ) : getCategoryFeedbackDisplay()}
        <br />

        { getGradeAdjustmentButtons()}

        {step === "feedbackReview" && (
          <div className={classes.userExperienceMain}>
            <div className={classes.userExperienceEmptyDiv}></div>
            <div className={classes.fullWidth}>
              <h2 className={`${classes.title}`}>
                <br />
                Tell us about your experience
              </h2>
              <div
                className={`${classes.question}`}
                style={{ position: "relative" }}
              >
                <textarea
                  rows={4}
                  className={classes.userExperience}
                  value={userFeedback}
                  onChange={(e) => setUserFeedback(e.target.value)}
                  placeholder={
                    isUserFeedbackSent
                      ? afterSentUserFeedbackPlaceHolder
                      : userFeedbackPlaceholder
                  }
                />
                <FontAwesomeIcon
                  className={`${classes.icon} ${classes.planeIcon}`}
                  icon={faPaperPlane}
                  onClick={userFeedbackSendHandler}
                />
              </div>
            </div>
          </div>
        )}

        {errMsg ? (
            <div className={`${util.alert} ${util['alert--danger']}`}>{errMsg}</div>
          ) : null}

        {step === "feedbackReview" ? (
          <div className={`${classes['form-actions']} ${classes['form-actions--terminal']}`}>
            <ActionButton
              text="Export to Google Docs"
              subText="(A ready-to-use exported file will open in a new tab. You can come back to this page at any time)"
              variant="secondary"
              handleOnClick={exportHandler}
              isDisabled={isGradeCategoryFeedbackLoading || isGradeGeneralFeedbackLoading}
            />
            <ActionButton
              text="Grade next student"
              subText="(Make sure to export current report. Data will not be saved.)"
              handleOnClick={gradeAnotherHandler}
              variant="secondary"
            />
            <ActionButton
              text="Back to Home"
              variant="secondary"
              handleOnClick={backToHomeHandler}
            />
          </div>
        ) : !adjustingRubricGrades && (
          <div className="navigationButtonsContainer">
            <div className="form-actions form-actions--flow" style={{ width: "90%" }}>
              <button
                type="button"
                className={`${util.btn} ${util['btn--ghost']} navigationButton`}
                onClick={ () => {
                  logAppUse(step, previousStep);
                  navigate(previousStep);
                }}
              >
                Back
              </button>
              {!(isGradeCalibratedRubricFeedbackLoading || calibratedRubricFeedbackPreLoad) && (
                <button
                  className={`${util.btn} ${util['btn--secondary']} navigationButton`}
                  style={{ width: "600px" }}
                  onClick={ () => {
                    logAppUse(step, "feedbackReview");
                    navigate("/grading/feedbackReview");
                  }}
                >
                  Done adjusting, continue<br/>
                  <span style={{fontSize: "0.8em", fontWeight:"normal"}}>
                    (You will be able to manually edit the feedback in the next step)
                  </span>
                </button>
              )}
            </div>
          </div>

        )}

        {
          /* Change to true to display the download link for grading inputs */
          Object.keys(gradingInputs).length > 0 && false && (
          <a
            href={generateDownloadLink(gradingInputs)}
            download="gradingInputs.json"
            style={{ display: 'block', marginTop: '20px' }}
          >
            Download Grading Inputs
          </a>
        )}
      </div>

      {/* Google drive permission Modal */}
      <SignInInfoModal
        isOpen={infoModal}
        cancelHandler={() => setInfoModal(false)}
        continueHandler={signInInfoContinueHandler}
        error={exportError}
      />

      {/* Export Button Modal */}
      <ExportGradingModal
        isOpen={exportModal}
        backHandler={backBtnExportModalHandler}
        continueHandler={continueBtnExportModalHandler}
        exportCount={{
          rubricCount: rubricCriteriaFb.feedbacks?.filter((fb) => fb.selected)
            ?.length,
          categoryCount: categoryFb.feedbacks?.filter((fb) => fb.selected)
            ?.length,
          generalFeedbacks: generalFb.feedbacks?.reduce((acc, fb) => {
              acc[fb.generalCategory] = fb?.selected;
              return acc;
            }, {}),            
          overallFeedback: overallFb?.selected
        }}
      />

      {/* Back To Home Modal */}
      <ModalWrapper
        modalProps={{
          isOpen: backToHomeModal,
          description: `Are you sure you want to leave this page? Your current work will be lost.`,
          leftBtnHandler: backToHomeCancelBtnHandler,
          rightBtnHandler: backToHomeConfirmBtnHandler,
          buttons: {
            leftBtn: "Cancel",
            rightBtn: "Confirm",
          },
        }}
      />

      {/* Request grade from teacher modal */}
      <InputModal
        modalProps={{
          isOpen: assignGradeModal,
          description: `What overall grade did you give this student? This feedback helps the AI understand your grading standards.`,
          rightBtnHandler: () => {
            setAssignGradeModal(false);
            postGradeCheckHandler();
            setPostGradeCheckHandler(() => () => {});
            saveAndExportEndpoint({ doExport: false});
          },
          buttons: {
            rightBtn: "Continue",
          },
        }}
        InputComponent={GradeTextInput}
        inputProps={{
            value: teacherGrade,
            onChange: (e) => setTeacherGrade(e.target.value),
            placeholder: "(Enter your grade here)",
        }}        
      />

      {/* Issue with upload modal */}
      <ErrorModal
        isOpen={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        titleText={"Potential issue with upload"}
        bodyText={fileUploadMessage}
      />
    </>
  );
}

export default FeedbackReview;
